(function () {
  function addToCart(variantId, btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var body = { id: Number(variantId), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = window.routes.cart_url;
        }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
      })
      .catch(function (e) { window.alert((e && e.description) || 'Impossible d’ajouter cet article.'); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-size');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn.getAttribute('data-variant-id'), btn);
  });
  // Galerie : précharge les 3 photos suivantes pour un passage instantané
  var nextMedia = document.querySelectorAll('.product__media-list .product__media-item:not(.is-active) img');
  for (var k = 0; k < Math.min(3, nextMedia.length); k++) { nextMedia[k].loading = 'eager'; }
  // Étiquette Nouveau / Best-seller à côté du titre
  var tag = document.querySelector('[data-pc-tag]'), h1 = document.querySelector('.product__title h1');
  if (tag && h1) h1.appendChild(tag);
  // Galerie mobile : points de navigation
  var mediaList = document.querySelector('.product__media-list');
  var mediaWrap = document.querySelector('.product__media-wrapper');
  if (mediaList && mediaWrap) {
    var slides = mediaList.querySelectorAll('.product__media-item');
    if (slides.length > 1) {
      var dots = document.createElement('div'); dots.className = 'pc-dots';
      slides.forEach(function (s, i) { var d = document.createElement('span'); if (i === 0) d.className = 'is-active'; dots.appendChild(d); });
      mediaWrap.appendChild(dots);
      var setDot = function () {
        var w = slides[0].getBoundingClientRect().width || 1;
        var idx = Math.round(mediaList.scrollLeft / w);
        dots.querySelectorAll('span').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      mediaList.addEventListener('scroll', setDot, { passive: true });
    }
  }
  var bar = document.querySelector('[data-pc-sticky]');
  var submit = document.querySelector('.product-form__submit');
  if (bar && submit) {
    var sizeEl = bar.querySelector('[data-pc-sticky-size]');
    var setSize = function () {
      var checked = document.querySelector('.product-form__input input[type="radio"]:checked');
      if (sizeEl) sizeEl.textContent = checked ? ' · ' + checked.value : '';
    };
    document.addEventListener('change', setSize); setSize();
    var update = function () {
      bar.hidden = submit.getBoundingClientRect().bottom > 0;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    var b = bar.querySelector('[data-pc-sticky-btn]');
    if (b) b.addEventListener('click', function () { submit.click(); });
  }
  // Bloc « Le look complet » dans la fiche produit
  var box = document.querySelector('[data-pc-lookbox]');
  if (box) {
    var money = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; };
    var pct = Number(box.getAttribute('data-discount')) || 0;
    var recalc = function () {
      var total = 0;
      box.querySelectorAll('[name="variant"]').forEach(function (el) {
        var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
        total += Number(opt.getAttribute('data-price')) || 0;
      });
      var full = box.querySelector('[data-lookbox-full]'), tot = box.querySelector('[data-lookbox-total]'), save = box.querySelector('[data-lookbox-save]');
      if (pct > 0) {
        var reduced = Math.round(total * (100 - pct) / 100);
        tot.textContent = money(reduced); full.textContent = money(total); full.hidden = false;
        save.textContent = 'Économisez ' + money(total - reduced); save.hidden = false;
      } else { tot.textContent = money(total); full.hidden = true; save.hidden = true; }
    };
    fetch((box.getAttribute('data-base') || '/collections/all') + '/' + box.getAttribute('data-look-tag') + '?section_id=pc-look-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-look-items]');
        if (!list || list.querySelectorAll('.pc-lookbox__tile').length < 2) return;
        box.querySelector('[data-lookbox-items]').appendChild(list);
        var n = list.querySelectorAll('.pc-lookbox__tile').length;
        box.querySelector('[data-lookbox-count]').textContent = n + ' pièces, 1 look' + (pct > 0 ? ', −' + pct + ' % sur l’ensemble' : '');
        box.addEventListener('change', recalc);
        recalc();
        box.hidden = false;
      })
      .catch(function () {});
    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var tiles = Array.prototype.slice.call(box.querySelectorAll('.pc-lookbox__tile'));
      if (window.pcLookDrawer && tiles.length) { window.pcLookDrawer.open({ tiles: tiles, pct: pct, code: box.getAttribute('data-code') || '' }); return; }
      var items = Array.from(box.querySelectorAll('[name="variant"]')).map(function (el) { return { id: Number(el.value), quantity: 1 }; }).filter(function (i) { return i.id; });
      if (!items.length) return;
      var btn = box.querySelector('button[type="submit"]'); btn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (res) {
          var code = box.getAttribute('data-code');
          if (pct > 0 && code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.routes.cart_url); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); } else window.location.href = window.routes.cart_url;
        })
        .catch(function (e) { window.alert((e && e.description) || 'Une pièce du look est indisponible dans cette taille.'); })
        .finally(function () { btn.disabled = false; });
    });
  }
})();

(function () {
  // Liste d'envies avec listes personnalisées, stockée sur l'appareil (localStorage)
  var KEY = 'pc_wishlist_v2', OLD = 'pc_wishlist_v1', PAGE = '/pages/liste-d-envies', DEFAULT_ID = 'default', DEFAULT_NAME = 'Mes envies';
  var uid = function () { return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); };
  var normalize = function (d) {
    if (!d || !Array.isArray(d.lists)) d = { lists: [] };
    d.lists = d.lists.filter(function (l) { return l && typeof l.id === 'string' && typeof l.name === 'string'; }).map(function (l) { l.items = Array.isArray(l.items) ? l.items.filter(function (h) { return typeof h === 'string'; }) : []; return l; });
    if (!d.lists.some(function (l) { return l.id === DEFAULT_ID; })) d.lists.unshift({ id: DEFAULT_ID, name: DEFAULT_NAME, items: [] });
    return d;
  };
  var write = function (d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} };
  var read = function () {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) return normalize(JSON.parse(raw));
      var old = JSON.parse(localStorage.getItem(OLD) || '[]');
      var d = normalize({ lists: [{ id: DEFAULT_ID, name: DEFAULT_NAME, items: Array.isArray(old) ? old : [] }] });
      if (Array.isArray(old) && old.length) { write(d); try { localStorage.removeItem(OLD); } catch (e) {} }
      return d;
    } catch (e) { return normalize(null); }
  };
  var all = function () { var seen = {}, out = []; read().lists.forEach(function (l) { l.items.forEach(function (h) { if (!seen[h]) { seen[h] = 1; out.push(h); } }); }); return out; };
  var findList = function (d, id) { for (var i = 0; i < d.lists.length; i++) if (d.lists[i].id === id) return d.lists[i]; return null; };
  var emit = function (action, handle, extra) { var det = { action: action, handle: handle || null, listId: (extra && extra.listId) || null, source: (extra && extra.source) || 'button', total: all().length }; document.dispatchEvent(new CustomEvent('pc:wish:change', { detail: det })); };
  var toast, toastTimer;
  var notify = function (msg, action) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'pc-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = '<span></span>' + (action ? '<button type="button" class="pc-toast__btn"></button>' : '') + '<a href="' + PAGE + '">Voir</a>';
    toast.firstChild.textContent = msg;
    if (action) { var b = toast.querySelector('.pc-toast__btn'); b.textContent = action.label; b.addEventListener('click', function () { toast.classList.remove('is-visible'); action.onClick(); }); }
    clearTimeout(toastTimer); requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, action ? 4500 : 3200);
  };
  var sync = function () {
    var list = all();
    document.querySelectorAll('[data-pc-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-pc-wish')) !== -1, t = b.getAttribute('data-pc-wish-title') || '';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Classer ou retirer ' + t + ' de mes listes' : 'Ajouter ' + t + ' à ma liste d’envies'));
      var lab = b.querySelector('[data-pc-wish-label]'); if (lab) lab.textContent = lab.getAttribute(on ? 'data-on' : 'data-off');
    });
    document.querySelectorAll('[data-pc-wish-link]').forEach(function (a) {
      var bubble = a.querySelector('[data-pc-wish-count]'), n = list.length;
      a.classList.toggle('is-active', n > 0);
      if (bubble) { bubble.hidden = n === 0; var s = bubble.querySelector('span'); if (s) s.textContent = n < 100 ? n : '99+'; }
    });
  };
  // Panneau « Enregistrer dans une liste »
  var sheet, sheetHandle, sheetTitle;
  var buildSheet = function () {
    sheet = document.createElement('div'); sheet.className = 'pc-wsheet'; sheet.hidden = true;
    sheet.innerHTML = '<div class="pc-wsheet__overlay" data-wsheet-close></div><div class="pc-wsheet__panel" role="dialog" aria-modal="true" aria-labelledby="pc-wsheet-title" tabindex="-1">' +
      '<header class="pc-wsheet__head"><div><h2 id="pc-wsheet-title">Enregistrer dans</h2><p class="pc-wsheet__sub" data-wsheet-sub></p></div><button type="button" class="pc-wsheet__close" data-wsheet-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>' +
      '<ul class="pc-wsheet__lists" data-wsheet-lists></ul>' +
      '<form class="pc-wsheet__new" data-wsheet-new><input type="text" maxlength="40" placeholder="Nouvelle liste (Soirée, Bureau, Cadeaux…)" aria-label="Nom de la nouvelle liste"><button type="submit" class="pc-btn">Créer</button></form>' +
      '<footer class="pc-wsheet__foot"><button type="button" class="pc-wsheet__remove" data-wsheet-remove>Retirer de toutes mes listes</button><a class="pc-link" href="' + PAGE + '">Voir mes listes</a></footer></div>';
    document.body.appendChild(sheet);
    sheet.querySelectorAll('[data-wsheet-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    sheet.querySelector('[data-wsheet-lists]').addEventListener('change', function (e) {
      var cb = e.target; if (!cb.matches('input[type="checkbox"]')) return;
      if (cb.checked) API.addTo(cb.getAttribute('data-list-id'), sheetHandle); else API.removeFrom(cb.getAttribute('data-list-id'), sheetHandle);
      renderSheet();
    });
    sheet.querySelector('[data-wsheet-new]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = e.target.querySelector('input'), id = API.createList(input.value);
      if (!id) { input.focus(); return; }
      API.addTo(id, sheetHandle); input.value = ''; renderSheet();
    });
    sheet.querySelector('[data-wsheet-new] input').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); sheet.querySelector('[data-wsheet-new]').dispatchEvent(new Event('submit', { cancelable: true })); } });
    sheet.querySelector('[data-wsheet-remove]').addEventListener('click', function () { var t = sheetTitle; API.remove(sheetHandle); closeSheet(); notify(t + ' a été retirée de vos listes.'); });
  };
  var renderSheet = function () {
    var d = read(), ul = sheet.querySelector('[data-wsheet-lists]'); ul.innerHTML = '';
    d.lists.forEach(function (l) {
      var on = l.items.indexOf(sheetHandle) !== -1, n = l.items.length;
      var li = document.createElement('li'); li.className = 'pc-wsheet__row' + (on ? ' is-on' : '');
      li.innerHTML = '<label><input type="checkbox" data-list-id="' + l.id + '"' + (on ? ' checked' : '') + '><span class="pc-wsheet__check" aria-hidden="true"></span><span class="pc-wsheet__name"></span><small class="pc-wsheet__count"></small></label>';
      li.querySelector('.pc-wsheet__name').textContent = l.name;
      li.querySelector('.pc-wsheet__count').textContent = n ? n + (n > 1 ? ' pièces' : ' pièce') : 'vide';
      ul.appendChild(li);
    });
    sheet.querySelector('[data-wsheet-remove]').hidden = !API.has(sheetHandle);
  };
  var openSheet = function (handle, title) {
    if (!sheet) buildSheet();
    sheetHandle = handle; sheetTitle = title || 'Cette pièce';
    sheet.querySelector('[data-wsheet-sub]').textContent = sheetTitle;
    renderSheet();
    sheet.hidden = false; document.body.classList.add('pc-wsheet-open');
    sheet.querySelector('.pc-wsheet__panel').focus();
  };
  var closeSheet = function () { if (!sheet) return; sheet.hidden = true; document.body.classList.remove('pc-wsheet-open'); };
  var API = {
    all: all,
    has: function (h) { return all().indexOf(h) !== -1; },
    lists: function () { return read().lists.map(function (l) { return { id: l.id, name: l.name, count: l.items.length, items: l.items.slice(), isDefault: l.id === DEFAULT_ID }; }); },
    listsOf: function (h) { return read().lists.filter(function (l) { return l.items.indexOf(h) !== -1; }).map(function (l) { return l.id; }); },
    addTo: function (listId, h, opts) { var d = read(), l = findList(d, listId); if (!l || !h) return false; if (l.items.indexOf(h) === -1) { l.items.unshift(h); write(d); } sync(); if (!(opts && opts.silent)) emit('add', h, { listId: listId, source: opts && opts.source }); return true; },
    removeFrom: function (listId, h, opts) { var d = read(), l = findList(d, listId); if (!l) return false; l.items = l.items.filter(function (x) { return x !== h; }); write(d); sync(); if (!(opts && opts.silent)) emit('remove', h, { listId: listId, source: opts && opts.source }); return true; },
    add: function (h, opts) { return API.addTo((opts && opts.listId) || DEFAULT_ID, h, opts); },
    remove: function (h, opts) { var d = read(); d.lists.forEach(function (l) { l.items = l.items.filter(function (x) { return x !== h; }); }); write(d); sync(); if (!(opts && opts.silent)) emit('remove', h, { source: opts && opts.source }); },
    toggle: function (h, opts) { return API.has(h) ? (API.remove(h, opts), false) : (API.add(h, opts), true); },
    createList: function (name) { name = (name || '').trim().slice(0, 40); if (!name) return null; var d = read(); if (d.lists.some(function (l) { return l.name.toLowerCase() === name.toLowerCase(); })) return d.lists.filter(function (l) { return l.name.toLowerCase() === name.toLowerCase(); })[0].id; var id = uid(); d.lists.push({ id: id, name: name, items: [] }); write(d); emit('list', null, { listId: id, source: 'page' }); return id; },
    renameList: function (id, name) { name = (name || '').trim().slice(0, 40); var d = read(), l = findList(d, id); if (!l || !name) return false; l.name = name; write(d); emit('list', null, { listId: id, source: 'page' }); return true; },
    deleteList: function (id) { if (id === DEFAULT_ID) return false; var d = read(); d.lists = d.lists.filter(function (l) { return l.id !== id; }); write(d); sync(); emit('list', null, { listId: id, source: 'page' }); return true; },
    clear: function (listId) { var d = read(); d.lists.forEach(function (l) { if (!listId || l.id === listId) l.items = []; }); write(d); sync(); emit('clear', null, { listId: listId, source: 'page' }); },
    openChooser: openSheet,
    defaultId: DEFAULT_ID,
    sync: sync
  };
  window.pcWishlist = API;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pc-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-pc-wish'), t = b.getAttribute('data-pc-wish-title') || 'Cette pièce';
    if (API.has(h)) { openSheet(h, t); return; }
    API.add(h);
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    notify(t + ' a rejoint vos envies.', { label: 'Classer', onClick: function () { openSheet(h, t); } });
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  new MutationObserver(function () { clearTimeout(window.__pcWishSync); window.__pcWishSync = setTimeout(sync, 60); }).observe(document.body, { childList: true, subtree: true });
  sync();
  document.dispatchEvent(new CustomEvent('pc:wish:ready'));
})();

(function () {
  // Fiche produit : lecture automatique des vidéos de la galerie (muettes, en boucle), bouton pour le son
  var items = document.querySelectorAll('.product__media-list deferred-media');
  if (!items.length) return;
  var videos = [];
  items.forEach(function (dm) {
    if (typeof dm.loadContent === 'function' && !dm.getAttribute('loaded')) dm.loadContent(false);
    var v = dm.querySelector('video'); if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true; v.controls = false; v.preload = 'auto';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pc-vsound'; btn.setAttribute('aria-label', 'Activer le son');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path class="pc-vsound__on" d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12"/><path class="pc-vsound__off" d="M16 9l5 6M21 9l-5 6"/></svg>';
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; btn.classList.toggle('is-on', !v.muted); btn.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son'); if (v.paused) v.play().catch(function () {}); });
    dm.appendChild(btn);
    videos.push(v);
  });
  if (!videos.length) return;
  var visible = function (v) { var r = v.getBoundingClientRect(); var vw = window.innerWidth, vh = window.innerHeight; var x = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0)), y = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)); return r.width > 0 && (x * y) / (r.width * r.height) > 0.5; };
  var refresh = function () { videos.forEach(function (v) { if (visible(v)) { if (v.paused) v.play().catch(function () {}); } else if (!v.paused) v.pause(); }); };
  var io = new IntersectionObserver(function () { refresh(); }, { threshold: [0, 0.5, 1] });
  videos.forEach(function (v) { io.observe(v); });
  var list = document.querySelector('.product__media-list'); var t;
  if (list) list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(refresh, 120); }, { passive: true });
  if (typeof window.pauseAllMedia === 'function') { var orig = window.pauseAllMedia; window.pauseAllMedia = function () { orig.apply(this, arguments); setTimeout(refresh, 50); }; }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  refresh();
})();

(function () {
  // Cartes produit : la vidéo du produit joue (muette, en boucle) quand la carte est visible
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } else if (!v.paused) v.pause(); }); }, { threshold: 0.3 });
  var setup = function () {
    document.querySelectorAll('.pc-card-video:not([data-ready])').forEach(function (w) {
      w.setAttribute('data-ready', '1'); var v = w.querySelector('video'); if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      v.addEventListener('playing', function () { w.classList.add('is-playing'); });
      io.observe(v);
    });
  };
  var t; setup();
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(setup, 150); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) document.querySelectorAll('.pc-card-video video').forEach(function (v) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }); });
})();

/* ===== Coloris : relie automatiquement les produits de même nom et même prix (un produit par couleur) ===== */
(function () {
  var box = document.querySelector('[data-pc-colors]');
  if (!box) return;
  var COLORS = ('noir noire noirs black blanc blanche white beige marron choco chocolat brown burgundy bordeaux bordeau gris grise grey gray anthracite ' +
    'bleu blue blu marine navy ciel nuit scuro royal jeans vert verte green kaki khaki army olive rose pink fuchsia rouge red jaune beurre yellow ' +
    'ecru creme cream taupe camel caramel mauve violet viola lila lilas prune rouille orange corail brick nude sable silver gold dore doree argent bronze ' +
    'multi color colors multicolor leopard clair fonce brut cow anis mint moutarde terracotta turquoise coffee cafe lait ivoire poudre pastel menthe cognac').split(' ');
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function split(title) {
    var w = norm(title).split(' '), orig = (title || '').trim().split(/\s+/), col = [];
    while (w.length > 2 && COLORS.indexOf(w[w.length - 1]) > -1) { w.pop(); col.unshift(orig.pop()); }
    return { base: w.join(' '), color: col.join(' '), query: orig.join(' ') };
  }
  function cents(v) { return Math.round(parseFloat(String(v).replace(',', '.')) * 100); }
  function thumb(url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  var me = split(box.dataset.title), price = parseInt(box.dataset.price, 10), handle = box.dataset.handle;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'search/suggest.json?q=' + encodeURIComponent(me.query) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=last')
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var list = ((((j || {}).resources || {}).results || {}).products || []).filter(function (p) {
        return split(p.title).base === me.base && cents(p.price) === price;
      }).map(function (p) {
        return { handle: p.handle, url: (p.url || (root + 'products/' + p.handle)).split('?')[0], color: split(p.title).color, img: thumb(p.image || (p.featured_image && p.featured_image.url)), available: p.available !== false, title: p.title };
      });
      if (!list.some(function (p) { return p.handle === handle; })) {
        list.push({ handle: handle, url: root + 'products/' + handle, color: me.color, img: box.dataset.img, available: box.dataset.available !== 'false', title: box.dataset.title });
      }
      if (list.length < 2) return;
      list.sort(function (a, b) { return (a.color || '').localeCompare(b.color || '', 'fr') || a.handle.localeCompare(b.handle); });
      var label = document.createElement('p'); label.className = 'pc-colors__label';
      label.innerHTML = me.color ? 'Coloris : <span></span>' : 'Coloris <em>' + list.length + ' au choix</em>';
      if (me.color) label.querySelector('span').textContent = me.color;
      var row = document.createElement('div'); row.className = 'pc-colors__row';
      list.forEach(function (p) {
        var a = document.createElement('a'); a.className = 'pc-colors__item' + (p.handle === handle ? ' is-current' : '') + (p.available ? '' : ' is-soldout');
        a.href = p.url; a.title = (p.color || p.title) + (p.available ? '' : ' (épuisé)');
        a.setAttribute('aria-label', a.title); if (p.handle === handle) a.setAttribute('aria-current', 'true');
        var img = document.createElement('img'); img.src = p.img; img.alt = p.color || p.title; img.decoding = 'async'; img.width = 56; img.height = 70;
        a.appendChild(img); row.appendChild(a);
      });
      box.appendChild(label); box.appendChild(row); box.hidden = false;
    }).catch(function () {});
})();
